import React, { useEffect, useState } from "react";

type Layer = { src: string; key: number };

// The hall of the guild on screen, behind the whole page. A new hall is loaded first and then
// fades in over the old one, so moving between guilds never flashes an empty wall.
export default function GuildBackdrop({ src }: { src: string }) {
  const [layers, setLayers] = useState<Layer[]>([{ src, key: 0 }]);

  useEffect(() => {
    let cancelled = false;
    const image = new Image();
    const show = () => {
      if (cancelled) return;
      setLayers((previous) => {
        const top = previous[previous.length - 1];
        return top.src === src ? previous : [top, { src, key: top.key + 1 }];
      });
    };
    image.onload = show;
    image.onerror = show;
    image.src = src;
    return () => {
      cancelled = true;
    };
  }, [src]);

  return (
    <div className="gh-backdrop" aria-hidden="true">
      {layers.map((layer) => (
        <div key={layer.key} className="gh-backdrop-hall" style={{ backgroundImage: `url("${layer.src}")` }} />
      ))}
      <div className="gh-backdrop-shade" />
    </div>
  );
}
